(function () {
  'use strict';

  var cfg = window.themeSingleVariantProduct || {};
  var variantImageMap = cfg.variantImageMap || {};
  var selectedVariantId = cfg.selectedVariantId != null ? String(cfg.selectedVariantId) : '';

  function slideIndexForVariant(variantId) {
    if (variantId == null || variantId === '') return undefined;
    var k = String(variantId);
    if (Object.prototype.hasOwnProperty.call(variantImageMap, k)) return variantImageMap[k];
    var n = Number(variantId);
    if (!isNaN(n) && Object.prototype.hasOwnProperty.call(variantImageMap, n)) return variantImageMap[n];
    return variantImageMap[variantId];
  }

  function initFlickityVariantGallery($) {
    if (!$.fn.flickity) return;

    setTimeout(function () {
      var $main = $('.product-main .carousel-main.product_gallery').first();
      if (!$main.length) {
        $main = $('.carousel-main.product_gallery').first();
      }
      var $nav = $('.product-main .carousel-nav').first();
      if (!$nav.length) {
        $nav = $('.carousel-nav').first();
      }
      if (!$main.length) return;

      function parseFlickityAttr($el) {
        if (!$el || !$el.length) return {};
        var raw = $el.attr('data-flickity');
        if (!raw) return {};
        try { return JSON.parse(raw); } catch (e) { return {}; }
      }

      var common = { imagesLoaded: true, adaptiveHeight: false };

      var mainInstance = window.Flickity && window.Flickity.data($main[0]);
      var navInstance  = $nav.length && window.Flickity && window.Flickity.data($nav[0]);

      if (mainInstance) {
        mainInstance.options.adaptiveHeight = false;
      } else {
        $main.add($nav).find('.carousel-cell').addClass('flickity').show();

        var mainOpts = $.extend({}, parseFlickityAttr($main), common);
        $main.flickity(mainOpts);

        if ($nav.length) {
          var navOpts = $.extend({}, parseFlickityAttr($nav), common);
          $nav.flickity(navOpts);
        }

        mainInstance = window.Flickity && window.Flickity.data($main[0]);
        navInstance  = $nav.length && window.Flickity && window.Flickity.data($nav[0]);
      }

      function selectImageForVariant(variantId, $context) {
        var slideIndex = slideIndexForVariant(variantId);
        if (slideIndex === undefined || isNaN(slideIndex)) return;
        var mainGallery;
        var navGallery;
        if ($context && $context.length) {
          var $productMain = $context.closest('.product-main');
          mainGallery = $productMain.length ? $productMain.find('.product_gallery') : $('.product_gallery');
          navGallery = $productMain.length ? $productMain.find('.carousel-nav') : $('.carousel-nav');
        } else {
          mainGallery = $('.product_gallery');
          navGallery = $('.carousel-nav');
        }
        if (mainGallery.data('flickity')) mainGallery.flickity('select', slideIndex);
        if (navGallery.data('flickity')) navGallery.flickity('select', slideIndex);
      }

      function onVariantChange(variantId, $context) {
        if (variantId) selectImageForVariant(variantId, $context);
      }

      function getVariantIdFromElement($el) {
        if ($el.attr('id') === 'variant__dropdown') {
          return $el.find('option:selected').attr('data-variant-id');
        }
        return $el.val() || $el.find('option:selected').val();
      }

      $(document).on('change', '#variant__dropdown', function () {
        onVariantChange(getVariantIdFromElement($(this)), $(this));
      });

      $(document).on('change', '.product-main select[name="id"], .product-main [data-variants]', function () {
        onVariantChange($(this).val(), $(this));
      });

      selectImageForVariant(selectedVariantId);

      var lastVariantId = selectedVariantId;
      var pollStart = Date.now();
      var pollId = setInterval(function () {
        if (Date.now() - pollStart > 15000) {
          clearInterval(pollId);
          return;
        }
        var variantId = null;
        var $context = null;
        var $dropdown = $('#variant__dropdown');
        var $formSelect = $('.product-main select[name="id"], .product-main [data-variants]');
        if ($dropdown.length) {
          variantId = getVariantIdFromElement($dropdown);
          $context = $dropdown;
        } else if ($formSelect.length) {
          variantId = $formSelect.val();
          $context = $formSelect;
        }
        if (variantId && String(variantId) !== lastVariantId) {
          lastVariantId = String(variantId);
          onVariantChange(variantId, $context);
        }
      }, 400);
    }, 10);
  }

  function initCarouselNavStaticClick($) {
    if (!$.fn.flickity) return;
    $('.carousel-nav').on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {
      $('.bundle__image_thumb').removeClass('is-selected');
      $(cellElement).addClass('is-selected');
      if (cellElement) {
        $('.product_gallery').flickity('select', cellIndex);
      }
    });
  }

  function initGuaranteeAndAccordions($) {
    $('.guarantee-popup-open').on('click', function () {
      $('.guarantee-popup').addClass('active');
    });
    $('.guarantee-popup-close, .overlay').on('click', function () {
      $('.guarantee-popup').removeClass('active');
    });

    $('.title_tab').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().stop().slideUp(500);
        $(this).next().find('p').removeClass('show');
      } else {
        $(this).addClass('active');
        $(this).next().stop().slideDown(500);
        $(this).parent().siblings().children('.title_tab').removeClass('active');
        $(this).parent().siblings().children('.inner_content').slideUp(500);
        $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
        $(this).next().find('p').addClass('show');
      }
    });

    $('.inside-title').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().stop().slideUp(500);
        $(this).next().find('p').removeClass('show');
      } else {
        $(this).addClass('active');
        $(this).next().stop().slideDown(500);
        $(this).parent().siblings().children('.inside-title').removeClass('active');
        $(this).parent().siblings().children('.inside-content').slideUp(500);
        $(this).parent().siblings().children('.inside-content').find('p').removeClass('show');
        $(this).next().find('p').addClass('show');
      }
    });
  }

  function injectSubscriptionWidgetCSS() {
    var widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return false;

    var cssUrl = cfg.subscriptionWidgetCssUrl;
    if (!cssUrl) return false;

    if (widget.shadowRoot) {
      var existingStyle = widget.shadowRoot.querySelector('style[data-subscription-widget-css]');
      if (existingStyle) return true;

      var tickSvgUrl = cfg.checkmarkSvgUrl || '';

      fetch(cssUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (cssText) {
          var style = document.createElement('style');
          style.setAttribute('data-subscription-widget-css', 'true');
          style.textContent = cssText.replace('TICK_SVG_URL_PLACEHOLDER', tickSvgUrl);
          widget.shadowRoot.appendChild(style);
        })
        .catch(function () {
          var link = document.createElement('link');
          link.setAttribute('data-subscription-widget-css', 'true');
          link.rel = 'stylesheet';
          link.href = cssUrl;
          widget.shadowRoot.appendChild(link);
        });
      return true;
    }
    var existingLink = document.querySelector('link[href="' + cssUrl + '"]');
    if (!existingLink) {
      var linkHead = document.createElement('link');
      linkHead.rel = 'stylesheet';
      linkHead.href = cssUrl;
      document.head.appendChild(linkHead);
    }
    return true;
  }

  function injectSubscriptionPriceLabels() {
    var widget = document.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) return;

    var subOption = widget.shadowRoot.querySelector('[part~="rc-purchase-option__subscription"][rc-selected]');
    if (subOption) {
      var subPricesContainer = subOption.querySelector('[part="rc-purchase-option__prices"]');
      if (subPricesContainer && !subPricesContainer.querySelector('.rc-price-per-bag')) {
        var discountedPriceEl = subPricesContainer.querySelector('[part="rc-purchase-option__discounted-price"]');
        if (discountedPriceEl) {
          var perBagSpan = document.createElement('span');
          perBagSpan.className = 'rc-price-per-bag';
          perBagSpan.textContent = '/ Bag';
          discountedPriceEl.insertAdjacentElement('afterend', perBagSpan);
        }
      }
    }

    var onetimeOption = widget.shadowRoot.querySelector('[part~="rc-purchase-option__onetime"]');
    if (onetimeOption) {
      var onetimePricesContainer = onetimeOption.querySelector('[part="rc-purchase-option__prices"]');
      if (onetimePricesContainer && !onetimePricesContainer.querySelector('.rc-price-per-bag')) {
        var onetimePriceEl = onetimePricesContainer.querySelector('[part="rc-purchase-option__price"]');
        if (onetimePriceEl) {
          var onetimePerBag = document.createElement('span');
          onetimePerBag.className = 'rc-price-per-bag';
          onetimePerBag.textContent = ' / Bag';
          onetimePriceEl.insertAdjacentElement('afterend', onetimePerBag);
        }
      }
    }
  }

  function initSubscriptionWidgetCSS() {
    var injectScheduled = false;
    function scheduleInject() {
      if (injectScheduled) return;
      injectScheduled = true;
      requestAnimationFrame(function () {
        injectScheduled = false;
        injectSubscriptionWidgetCSS();
        injectSubscriptionPriceLabels();
      });
    }

    injectSubscriptionWidgetCSS();
    injectSubscriptionPriceLabels();

    var observer = new MutationObserver(function () {
      if (document.querySelector('recharge-subscription-widget')) {
        scheduleInject();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(function () {
      injectSubscriptionWidgetCSS();
      injectSubscriptionPriceLabels();
    }, 1000);
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
      initFlickityVariantGallery($);
      initCarouselNavStaticClick($);
      initGuaranteeAndAccordions($);
    });
  }

  function scheduleSubscriptionWidgetInit() {
    var run = function () {
      initSubscriptionWidgetCSS();
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2500 });
    } else {
      run();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSubscriptionWidgetInit);
  } else {
    scheduleSubscriptionWidgetInit();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-flavor-picker]')) return;
    if (t.value) window.location.href = t.value;
  });
})();
